// extracted by mini-css-extract-plugin
export default {"clickable":"nDEeB0"};